import { send_request } from './Request';

const BILLING_PREFIX = 'authz-service/v3/billing';

function isSuccessfulResponse(response) {
  return (
    response &&
    response.status === 200 &&
    response.data &&
    !response.isAxiosError &&
    !response.response
  );
}

export async function fetchSubscription() {
  const response = await send_request(`${BILLING_PREFIX}/subscription`, '', {}, 'GET');
  return isSuccessfulResponse(response) ? response.data : null;
}

export async function fetchCreditBalance() {
  const response = await send_request(`${BILLING_PREFIX}/credits/balance`, '', {}, 'GET');
  return isSuccessfulResponse(response) ? response.data : null;
}

export async function fetchCreditHistory(limit = 50) {
  const response = await send_request(
    `${BILLING_PREFIX}/credits/history`,
    '',
    { limit },
    'GET'
  );
  return isSuccessfulResponse(response) ? response.data || [] : [];
}

export async function fetchCreditUsage({ from, to, reason, page = 0, size = 50 } = {}) {
  const response = await send_request(
    `${BILLING_PREFIX}/credits/usage`,
    '',
    {
      from,
      to,
      reason,
      page,
      size,
    },
    'GET'
  );
  return isSuccessfulResponse(response)
    ? response.data || { events: [], summary: null, totalElements: 0 }
    : { events: [], summary: null, totalElements: 0 };
}

export async function fetchDailyCreditUsage({ from, to, days = 7 } = {}) {
  const params = from && to ? { from, to } : { days };
  const response = await send_request(
    `${BILLING_PREFIX}/credits/usage/daily`,
    '',
    params,
    'GET'
  );
  return isSuccessfulResponse(response) ? response.data || [] : [];
}

export async function downloadCreditUsageCsv({ from, to, reason } = {}) {
  const response = await send_request(
    `${BILLING_PREFIX}/credits/usage/export`,
    '',
    { from, to, reason },
    'GET',
    { Accept: 'text/csv' },
    'blob'
  );

  if (!response || response.status !== 200 || !response.data) {
    return false;
  }

  const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `credit-usage-${new Date().toISOString().slice(0, 10)}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  return true;
}

export async function fetchUsageSummary() {
  const response = await send_request(`${BILLING_PREFIX}/usage-summary`, '', {}, 'GET');
  return isSuccessfulResponse(response) ? response.data : null;
}
